import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/caf354db178998ce39818ca04198d64c.jpg"
          alt="Beautiful Renovated Space"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-12 flex flex-col justify-between py-32">
        <div className="mt-8">
          <h2 className="text-6xl lg:text-7xl font-bold text-white leading-tight lowercase" style={{ fontFamily: 'sans-serif' }}>
            laten we samen<br />
            bouwen
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <Link
            to="/contact"
            className="group flex items-center gap-4 bg-white/95 backdrop-blur-sm rounded-full pl-8 pr-2 py-2 hover:bg-white transition-all cursor-pointer"
          >
            <span className="text-base font-medium text-gray-900 whitespace-nowrap">
              Start Nu
            </span>
            <div className="w-12 h-12 rounded-full bg-gray-900 flex items-center justify-center group-hover:bg-gray-800 transition-colors">
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </div>
          </Link>

          <div className="text-right">
            <p className="text-xl text-white font-light leading-relaxed">
              Klaar om uw ruimte te transformeren?<br />
              Neem contact met ons op voor een consultatie
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;